const getCurrentLocalTime = () => {
	const now = new Date();
	let hours = now.getHours();
	const data = webobj.time_schedule.filter(
		(time) => time.min <= hours && time.max >= hours,
	);
	return data[0];
};

const localTime = (body) => {
	const time = getCurrentLocalTime();
	body.dataset.time = time.slug;
};

const timeText = (body) => {
	const time = getCurrentLocalTime();
	return time.text;
};

export { localTime, getCurrentLocalTime, timeText };
